function getchatIconPosition() {
	const screenWidth = window.innerWidth;
	let chatIconPosition = {};
	if (screenWidth <= 768) {
		// Small devices
		chatIconPosition = {
			alignment: "right",
			verticalPadding: 80,
            horizontalPadding: 5,
		};
		console.log("Setting Chat Icon for Small devices");
	} else {
		// Large devices
		chatIconPosition = {
			alignment: "right",
			verticalPadding: 5,
            horizontalPadding: 5,
		};
		console.log("Setting Chat Icon for Large devices");
	}

	return chatIconPosition;
}

window.onload = () => {
	console.log("Window has finished loading, loading Chat Icon");
	setTimeout(function () {
		Kustomer.start({
			brandId: "6776c22cc147a1c004a031cb",
			chatIconPosition: getchatIconPosition(),
			hideChatIcon: false,
		});
	}, 1000);
};


